import { hydrateWidgets, setFunctional } from '@utils'
import { Atf } from '../../widgets/DVWebNodeDetail/widgets/Atf'
import { Btf } from '../../widgets/DVWebNodeDetail/widgets/Btf'
import { Additional } from '../../widgets/DVWebNodeDetail/widgets/Additional'

// At the moment hydrateWidgets will be executed after the HTML parsed
// therefore there is no point trying to hydrate ATF, BTF and Additional separately
// TODO: Change this once hydrateWidgets can support async loading
// https://i.amazon.com/issues/PVWeb-419
// Furthermore, by having them in the same file, the widgets can share the same store

// Give back control to browser between hydrations to avoid freezing for too long
const oneMoment = () => new Promise((res) => setTimeout(res));

(async () => {
  hydrateWidgets(Atf)
  setFunctional() // Used for clickToInteractive CSM metric
  await oneMoment()
  hydrateWidgets(Btf)
  await oneMoment()
  hydrateWidgets(Additional)
})()
